//dev
// module.exports.fastUrl = "http://fastview-dev-cn.51ake.com"
// module.exports.baseUrl = "http://cms-dev-api.51ake.com"

//pro
module.exports.baseUrl = "http://cms-pro-api.cadwonder.net"
module.exports.fastUrl = "http://www.cadwonder.net"
    //  3dview:http://3dview.cadwonder.net


//////////////////
// WEBPACK FOOTER
// ./config/build-config.js
// module id = lljX
// module chunks = 21